import { Buffer } from "buffer";
 
// Entry path
const BASE_PATH: string = "";
 
/* Host names */
const HOSTS = {
  POC: "poc01.kshema.co",
  CROPS_POC: "poc02.kshema.co",
  UAT: "uat01.kshema.co",
  CROPS_UAT: "uat02.kshema.co",
  PREPROD: "preprod01.kshema.co",
  CROPS_PREPROD: "preprod02.kshema.co",
  PROD: "prod01.omdc.co.in",
  GIS_PROD: "prod01.kshema.co",
  CROPS_PROD:"prod02.kshema.co"
};
 let isGis:boolean=true;
const CURRENT_ENV = process.env.REACT_APP_ENV || "development";
 
const ENV_HOSTS: { [key: string]: string } = {
  poc: HOSTS.POC,
  uat: HOSTS.UAT,
  preprod: HOSTS.PREPROD,
  production: HOSTS.PROD,
};
 
const CROPS_ENV_HOSTS: { [key: string]: string } = {
  poc: HOSTS.CROPS_POC,
  uat: HOSTS.CROPS_UAT,
  preprod: HOSTS.CROPS_PREPROD,
  production: HOSTS.CROPS_PROD,
};
const GIS_ENV_HOSTS:{ [key: string]: string } = {
  poc: HOSTS.POC,
  uat: HOSTS.UAT,
  preprod: HOSTS.PREPROD,
  production: HOSTS.GIS_PROD,
};
 
const CURRENT_HOST: string = ENV_HOSTS[CURRENT_ENV] || HOSTS.POC;
const CROPS_HOST: string = CROPS_ENV_HOSTS[CURRENT_ENV] || HOSTS.CROPS_POC;
const GIS_HOST:string=GIS_ENV_HOSTS[CURRENT_ENV]|| HOSTS.POC
console.log(CURRENT_ENV, "CURRENT_ENV");
 
const CURRENT_PATH: string = `https://${CURRENT_HOST}/${BASE_PATH}`;
export const CROPS_PATH: string = `https://${CROPS_HOST}/${BASE_PATH}`;
const GIS_PATH:string=`https://${GIS_HOST}/${BASE_PATH}`;
 
// Types of methods
export const method = {
  DELETE: "DELETE",
  POST: "POST",
  GET: "GET",
  PUT: "PUT",
  PATCH: "PATCH",
  OPTIONS: "OPTIONS",
};
 
const credentials = {
  Username: "",
  Password: "i luv Kshema",
};
 
// API paths
export const paths = {
  BASE_URL: CURRENT_PATH,
  CROPS_URL: CROPS_PATH,
  GIS_URL:GIS_PATH,
  basicAuthString: Buffer.from(`${credentials.Username}:${credentials.Password}`).toString("base64"),
  AUTHENTICATION_ENDPOINT: "REST/authentication",
  CHM_STATES_DATA: "chmops/chmOps/get-states",
  CHM_DISTRICTS_DATA: "chmops/chmOps/get-districts",
  CHM_MANDAL_DATA:"chmops/chmOps/get-mandals",
  CHM_LEVEL4_DATA: "chmops/chmOps/getLevel4Data",
  CHM_LEVEL5_DATA: "chmops/chmOps/getLevel5Data",
  CHM_VILLAGES_DATA: "chmops/chmOps/get-villages",
  CHM_SEASON_DATA: "chmops/chmOps/get-seasons",
  CHM_CROPS_DATA: "chmops/chmOps/get-crops",
  CHM_GET_CHM_INFO: "chmops/chmOps/chm-info",
  CHM_GET_CHM_INFO_BY_ID: "chmops/chmOps/chm-form-data",
  GIS_COMPUTEINDEX: "gischm/computeindex",
  GIS_CHM_CHART: "gischm/fetchdata",
  CHM_IMAGES: "chmops/chmOps/get-images",
  CHM_VIEWMAP_POLYGON_VALUES: "chmops/chmOps/view-map-data",
  CHM_EXCEL_DOWNLOAD_DATA: "chmops/chmOps/excel-download",
  CHM_EXCEL_SHEET_UPLOAD: "chmops/chmOps/import-excel",
  CHM_SURVEYOR_DATA: "chmops/chmOps/get-surveyors-data",
  CHM_ASSIGNE_SURVEYER: "chmops/chmOps/assign-surveyor",
  CHM_ERORLOGS: "chmops/chmOps/error-logs",
 
  //ICV Api Endpoints
  ICV_STATE_DATA:"cropwatch-ops/location-master/get-states",
  ICV_DISTRICTS_DATA:'cropwatch-ops/location-master/get-districts',
  ICV_MANDALS_DATA:'cropwatch-ops/location-master/get-mandals',
  ICV_PMFBY_VILLAGES_DATA:'cropwatch-ops/location-master/get-pmfby-mapped-villages',
  ICV_VILLAGES_DATA:'cropwatch-ops/location-master/get-villages',
  ICV_CROPS_MASTER_DATA:'cropwatch-ops/v1/crop-master',
  ICV_SEASONS_DATA:"cropwatch-ops/season-master",
  ICV_YEAR_DATA:"api/ncip/v1/master/year",
  ICV_CCE_USERS_DATA:'cropwatch-ops/v1/cce-users',
  ICV_ASSIGN_SURVEYOR:'cropwatch-ops/icv/assign-surveyors',
  ICV_GET_INFO:'cropwatch-ops/icv',
  NCIP_SEARCH_INFO:'api/ncip/v1/search',
  ICV_LEVEL5_DATA:'cropwatch-ops/location-master/get-level5',
  ICV_LEVEL6_DATA:'cropwatch-ops/location-master/get-level6',
  ICV_DOWNLOAD_CSV:'cropwatch-ops/icv/report',
  ICV_POLICY_REPORT:'cropwatch-ops/icv/report-with-policy-data',
 
  ICV_AZURE_FILE_SERVICE:'azure-file-service/v1.1/get_doc/',
  
  GET_ICV_DATA:'cropwatch-ops/icv/activities',
  ICV_SURVEY_STATUS: 'cropwatch-ops/status-master/icv',
  QC_REVIEW: 'cropwatch-ops/icv/qc-review',
  ASSIGN_QC: 'cropwatch-ops/icv/assign-qc',
  REASSIGN_QC: 'cropwatch-ops/icv/reassign-qc',
  ON_HOLD:'cropwatch-ops/icv/update',
  
  // Role Management Endpoint
  ROLE_MANAGEMENT: 'cropwatch-ops/role-management',


  //IEC
  GET_SEASONS_DATA_ENDPOINT: 'iecops/iecOps/get-seasons',
  GET_ALL_STATES_ENDPOINT: 'chmops/chmOps/get-states',
  GET_ALL_DISTRICTS_ENDPOINT: 'chmops/chmOps/get-districts',
  GET_ALL_TEHSIL_ENDPOINT: 'chmops/chmOps/get-mandals',
  GET_ACTIVITIES_ENDPOINT: 'iecops/iecOps/get-iec-activities',
  GET_IEC_INFO_ENDPOINT: 'iecops/iecOps/iec-info',
  GET_FORM_DATA_ENDPOINT: 'iecops/iecOps/iec-form-data',
  GET_Images_ENDPOINT: 'iecops/iecOps/get-images',
  GET_EXCEL_Download_ENDPOINT: 'iecops/iecOps/excel-download',
  GET_SURVEYOR_ENDPOINT: 'iecops/iecOps/get-surveyors-data',
};
 
export const METHOD = {
  POST: "POST",
  GET: "GET",
  PUT: "PUT",
  PATCH: "PATCH",
};